module.exports = __webpack_public_path__ + "static/Hvordan-bestille-time-66e4f410027fe0feafd0e8671fba2ee3.mp4";